import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

const BooksyColorIcon = (props: IconProps) => (
  <Icon
    height='full'
    viewBox='0 0 225 225'
    width='auto'
    fill='currentcolor'
    {...props}
  >
    <path
      d='M0 0 C3.96 0 7.92 0 12 0 C12 9.57 12 19.14 12 29 C16.95 26.53 16.95 26.53 22 24 C30.88 21.78 38.88 22.68 47 27 C54.46 32.44 60.39 38.62 62.68 47.79 C64.4 59.79 62.86 69.95 55.86 79.86 C50.73 85.76 43.9 90.3 36 91 C17.71 92.25 5.49 86.83 -9.24 76.24 C-11.62 74.54 -14 72.84 -16.38 71.15 C-17.83 70.12 -19.26 69.08 -20.69 68.03 C-26.18 64.3 -30.63 63.12 -37.29 63.47 C-41.52 64.3 -43.15 65.79 -46 69 C-46.41 69.71 -46.81 70.42 -47.23 71.16 C-49 73 -49 73 -52.14 73.39 C-53.31 73.34 -54.48 73.3 -55.69 73.25 C-56.87 73.21 -58.05 73.18 -59.26 73.14 C-60.17 73.09 -61.07 73.05 -62 73 C-61.1 65.52 -57.45 61.51 -52.31 56.25 C-46.26 51.59 -38.28 49.21 -30.68 49.55 C-23.14 50.82 -16.36 53.6 -10.6 58.64 C-7.63 61.16 -4.4 63.31 -1.19 65.5 C-0.48 65.98 0.23 66.47 0.95 66.96 C11.09 73.83 20.29 79.46 33 78 C38.65 76.76 42.96 74.75 46.62 70.19 C50.25 64.01 49.98 56.92 49 50 C48.06 47.97 47.08 45.96 46 44 C46 43.34 46 42.68 46 42 C45.46 41.73 44.93 41.46 44.38 41.19 C42.63 40.32 40.93 39.37 39.25 38.38 C33.86 36.09 29.19 36.42 23.75 38.19 C20.06 39.73 18.16 41.56 16 45 C15.44 45.85 14.89 46.69 14.31 47.56 C12.39 52.6 12.25 57.65 12 63 C7.6 62.73 4.71 60.95 1.5 58.1 C-1.63 53.72 -0.84 48.33 -0.68 43.16 C-0.67 41.93 -0.66 40.7 -0.65 39.42 C-0.61 35.49 -0.53 31.56 -0.44 27.62 C-0.4 24.95 -0.37 22.28 -0.34 19.61 C-0.26 13.07 -0.14 6.54 0 0 Z '
      strokeWidth='2'
      stroke='currentColor'
      transform='translate(90,50) scale(1.5)'
    />
  </Icon>
);

export default BooksyColorIcon;
